import React from "react";
import { useNavigate } from "react-router-dom";
import { BRL, PCT } from "../formato";

const MAX_ITENS = 3;
const num = (v) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 3 });

/**
 * Avisos do topo (modelo do dono): estoque crítico e CMV do mês.
 * Decisões do dono: sem alerta de iFood pausado; estoque mostra só saldo e
 * mínimo; o limite do CMV é a maior meta de CMV da Ficha Técnica.
 * Desde 23/10/2026: SÓ APARECE O QUE É PROBLEMA ("se está tudo bem, não é
 * aviso") — estoque em dia e CMV dentro do limite não mostram nada — e cada
 * aviso é uma faixa fina de uma linha (no celular, o texto e os botões quebram).
 */
export default function Alertas({ mes }) {
  const navigate = useNavigate();
  if (!mes) return null;
  const estoque = <AlertaEstoque itens={mes.estoque_critico || []} onRepor={() => navigate("/admin/compras")}
    onEstoque={() => navigate("/admin/estoque")} />;
  const cmv = <AlertaCmv cmv={mes.cmv || {}} onFicha={() => navigate("/admin/produtos")} />;
  if (!temEstoque(mes) && !temCmv(mes.cmv || {})) return null;
  return <div className="vg-alertbar" aria-label="Avisos">{estoque}{cmv}</div>;
}

const temEstoque = (mes) => (mes.estoque_critico || []).length > 0;

/** Metade ou mais do faturamento sem custo: o % fica artificialmente baixo. */
const incompleto = (cmv) => cmv.faturamento > 0 && cmv.vendas_sem_custo >= cmv.faturamento / 2;
const temCmv = (cmv) => cmv.percentual != null && (incompleto(cmv) || cmv.percentual > cmv.limite);

function Aviso({ tipo, icone, titulo, detalhe, children }) {
  return (
    <div className={`vg-al ${tipo}`}>
      <span className="vg-ic">{icone}</span>
      <div className="vg-al-tx"><b>{titulo}</b>{detalhe && <small title={detalhe}>{detalhe}</small>}</div>
      <div className="vg-al-acoes">{children}</div>
    </div>
  );
}

function AlertaEstoque({ itens, onRepor, onEstoque }) {
  if (!itens.length) return null;
  const desc = (it) => `${it.nome} ${num(it.saldo)}/${num(it.minimo)} ${it.unidade}`.trim();
  if (itens.length === 1) {
    const it = itens[0];
    return (
      <Aviso tipo="bad" icone="!" titulo={`${it.nome} no estoque mínimo`}
        detalhe={`Saldo ${num(it.saldo)} ${it.unidade} · mínimo ${num(it.minimo)} ${it.unidade}`}>
        <button type="button" onClick={onRepor}>Repor</button>
      </Aviso>
    );
  }
  const resto = itens.length - MAX_ITENS;
  const detalhe = itens.slice(0, MAX_ITENS).map(desc).join(" · ") + (resto > 0 ? ` · +${resto}` : "");
  return (
    <Aviso tipo="bad" icone={itens.length} titulo={`${itens.length} insumos no estoque mínimo`} detalhe={detalhe}>
      <button type="button" onClick={onRepor}>Repor</button>
      <button type="button" onClick={onEstoque}>Ver estoque</button>
    </Aviso>
  );
}

function AlertaCmv({ cmv, onFicha }) {
  if (!temCmv(cmv)) return null;
  if (incompleto(cmv)) {
    return (
      <Aviso tipo="warn" icone="!" titulo="CMV incompleto"
        detalhe={`${BRL(cmv.vendas_sem_custo)} de ${BRL(cmv.faturamento)} vendidos no mês sem ficha técnica`}>
        <button type="button" onClick={onFicha}>Ver fichas</button>
      </Aviso>
    );
  }
  return (
    <Aviso tipo="warn" icone="!" titulo="CMV acima do recomendado"
      detalhe={`${PCT(cmv.percentual)} no mês · limite ${cmv.limite}%`}>
      <button type="button" onClick={onFicha}>Ver fichas</button>
    </Aviso>
  );
}
